import { createTheme as t } from "flowbite-react";
const r = t({
  dropdown: {
    arrowIcon: "ml-2 h-4 w-4",
    content: "py-1 focus:outline-hidden dark:bg-[#DCE6FF] bg-[#DCE6FF]",
    floating: {
      animation: "transition-opacity",
      arrow: {
        base: "absolute z-10 h-2 w-2 rotate-45",
        style: {
          dark: "bg-gray-900 dark:bg-gray-700",
          light: "bg-white",
          auto: "bg-white dark:bg-gray-700"
        },
        placement: "-4px"
      },
      base: "dark:bg-white/80 backdrop-blur-[15px] shadow-lg z-9000 w-fit divide-y rounded focus:outline-hidden",
      content: "bg-white/10 dark:bg-white/10 backdrop-blur-[15px] rounded shadow-lg py-1 text-sm text-gray-700 dark:text-gray-700",
      divider: "my-1 h-px bg-gray-100 dark:bg-gray-600",
      header: "block px-4 py-2 text-sm text-gray-700 dark:text-dark",
      hidden: "invisible opacity-0",
      item: {
        container: "",
        base: "flex w-full cursor-pointer items-center justify-start px-4 py-2 text-sm dark:text-dark text-dark focus:outline-hidden dark:hover:text-white dark:focus:bg-blue-800 dark:focus:text-white",
        icon: "mr-2 h-4 w-4"
      },
      style: {
        dark: "bg-red-700 dark:bg-white/80 backdrop-blur-[15px] z-9000 text-dark rounded shadow-lg",
        light: "border border-gray-200 bg-white text-gray-900",
        auto: "bg-white/10 dark:bg-[#DCE6FF] backdrop-blur-[15px] rounded shadow-lg z-9000 text-base border border-gray-200 text-dark dark:text-dark"
      },
      target: "w-fit"
    },
    inlineWrapper: "flex items-center"
  }
}).dropdown;
export {
  r as theme
};
